import { IS_DEVELOPMENT } from '@page/auth/config';

/**
 * In development mode, logs the intended action instead.
 */
export const executeSafely = <R>(actionDescription: string, actionFn: () => R): R | void => {
  if (IS_DEVELOPMENT) {
    console.log(`[DEV ONLY] ${actionDescription}`);
  } else {
    return actionFn();
  }
};
